import { ArrowRight } from 'lucide-react'
import React from 'react'
import whatsappIcon from '../../../assets/img/landing/whatsapp-logo.png'
import discordIcon from '../../../assets/img/landing/discord-logo.png'
import youtubeIcon from '../../../assets/img/landing/youtube-logo.png'
import emailIcon from '../../../assets/img/landing/email-logo.svg'
import phoneIcon from '../../../assets/img/landing/phone-icon.svg'
import blogIcon from '../../../assets/img/landing/blog-icon.svg'
import './ContactUs.scss'
import Header from '../landing/landing-comp/Header'
import Footer from '../landing/landing-comp/Footer'

const ContactUs = () => {
  const contactMethods = [
    {
      icon: emailIcon,
      title: "Email Us",
      description: "Get support via email",
      link: "mailto:support@fnotrader.com",
      linkText: "support@fnotrader.com"
    },
    {
      icon: whatsappIcon,
      title: "WhatsApp",
      description: "Chat with us on WhatsApp", 
      link: "https://wa.me/+918885635467",
      linkText: "+91 888 563 5467"
    },
    {
      icon: discordIcon,
      title: "Discord",
      description: "Join our Discord community",
      link: "https://discord.gg/q57HhRMg",
      linkText: "Join Discord"
    },
    {
      icon: youtubeIcon,
      title: "YouTube",
      description: "Watch trading tutorials",
      link: "https://www.youtube.com/channel/UCZawT_YUYCmK3fT9FLd6TPA",
      linkText: "Visit Channel"
    },
    {
      icon: blogIcon,
      title: "Blog",
      description: "Read latest articles",
      link: "https://www.blog.fnotrader.com/",
      linkText: "Visit Blog"
    },
  ];

  return (
    <>
    <Header />
    <section className="contact-section">
      <div className="contact-container">
        <div className="header">
          <h2 className="title">Contact Us</h2>
          <p className="subtitle">We're here to help! Reach out to us for any questions or support needs</p>
        </div>
        <div className="contact-grid">
          {contactMethods.map((method, index) => (
            <div key={index} className="contact-card">
              <div className="contact-card-header">
                <img src={method.icon} alt={method.title} className="icon" />
                <div>
                  <h3 className="card-title">{method.title}</h3>
                  <p className="card-description">{method.description}</p>
                </div>
              </div>
              <a
                href={method.link}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                {method.linkText}
                <ArrowRight className="arrow-icon" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
    <Footer />
  </>
  )
}

export default ContactUs